import { render, staticRenderFns } from "./AddState.vue?vue&type=template&id=28a9470e"
import script from "./AddState.vue?vue&type=script&lang=js"
export * from "./AddState.vue?vue&type=script&lang=js"
import style0 from "./AddState.vue?vue&type=style&index=0&id=28a9470e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports